<template>
  <div>
    <header class="header_area  fixed-top">
      <div class="container-fluid">
          <div class="row">
              <div class="col-md-12">
                  <div class="header_main_wrap">
                      <div class="header_left">
                        <div class="logo">
                          <router-link :to="{name: 'dashboard'}">
                            <img src="assets/media/images/logo.png" alt="">
                          </router-link>
                        </div>
                        <div class="header_main_menu">
                            <div class="common_dropdown ">
                                <div class="btn-group dropdown-center">
                                    <button v-if="selectedService" type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                        {{ selectedService?.name }}
                                    </button>
                                    <button v-else type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                        Select Service Provider
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li>
                                            <div class="dropdown-item p_0 border_top_none" type="button">
                                                <div class="service_search">
                                                    <input type="text" placeholder="Search">
                                                    <button>
                                                        <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M7 1a6 6 0 0 1 4.714 9.713L16 15l-1 1-4.287-4.286A6 6 0 1 1 7 1zm0 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9z"></path></svg>
                                                    </button>
                                                </div>
                                            </div>
                                        </li>
                                        <li v-for="service in services" :key="`service_${service.id}`">
                                          <button class="dropdown-item" type="button" @click="setSelectedService(service?.id)"> <span>{{ service?.name }}</span>  </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="header_main_menu_list">
                                <ul>
                                    <!-- <li ><a href="#">Resource Management</a></li> -->
                                    <li v-for="(tab, index) in allTabs"
                                        :key="`header_tab_${tab.id}`"
                                        :class="{ active: tab.id === activeTabId }"
                                        @click="selectTab(tab.id)"
                                    >
                                        <a
                                            href="#"
                                            style=""
                                        >
                                            {{ formatText(tab.title) }}
                                            <span
                                                v-if="index > 0"
                                                class="close_item"
                                                @click.stop="closeTheTab(tab.id)"
                                            >
                                                <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g stroke-width="1.2" stroke-linecap="round" stroke="currentColor" fill="none"><path fill="currentColor" d="m3 3 10 10"></path><path fill="currentColor" d="M3 13 13 3"></path></g></svg>
                                            </span> 
                                        </a>
                                    </li>
                                    <li>
                                        <span class="pl_10" @click="addNewTab"><i class="lni lni-plus"></i></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                      </div>
                      <div class="header_right_menu">
                        <ul>
                            <!-- <li>
                                <div class="header_list_btn header_search_area">
                                    <div class="btn-group">
                                        <button type="button" class="btn btn-secondary dropdown-toggle no_arrow" data-bs-toggle="dropdown" aria-expanded="false">
                                            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M7 1a6 6 0 0 1 4.714 9.713L16 15l-1 1-4.287-4.286A6 6 0 1 1 7 1zm0 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9z"></path></svg>
                                        </button>
                                        <ul class="dropdown-menu dropdown-menu-end">
                                            <div class="header_search_inner">
                                                <div class="header_search_input">
                                                    <input type="text" placeholder="Enter a search word.">
                                                    <button><svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M7 1a6 6 0 0 1 4.714 9.713L16 15l-1 1-4.287-4.286A6 6 0 1 1 7 1zm0 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9z"></path></svg></button>
                                                </div>
                                                <div class="no_search_history">
                                                    <div class="inner">
                                                        <svg viewBox="0 0 28 37" xmlns="http://www.w3.org/2000/svg"><g transform="translate(0 .251)"><path fill="currentColor" transform="rotate(180 14 18.375)" style="fill:#e4e8ee" d="M0 0v28l9 9h19V0H0z" id="빼기_164"></path><path transform="translate(19)" style="opacity:.6" d="M0 9h9L0 0z" fill="#748095" id="패스_207011"></path><path transform="translate(5 14.767)" style="opacity:.6" d="M0 0h15.333v1.245H0z" fill="#748095" id="사각형_144341"></path><path transform="translate(5 17.257)" style="opacity:.6" d="M0 0h15.333v1.245H0z" fill="#748095" id="사각형_144342"></path><path transform="translate(5 12.276)" style="opacity:.6" d="M0 0h6.226v1.245H0z" fill="#748095" id="사각형_144343"></path></g></svg>
                                                        <p>There is no recent search history.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </ul>
                                    </div>
                                </div>
                            </li> -->
                            <li>
                                <div class="header_list_btn">
                                    <div class="btn-group dropdown-center">
                                        <button type="button" class="btn btn-secondary dropdown-toggle no_arrow" data-bs-toggle="dropdown" aria-expanded="false">
                                            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 20a10 10 0 1 1 10-10 10.011 10.011 0 0 1-10 10Zm-1.272-4.832v2.3h2.434v-2.297H8.728v-.003Zm1.333-9.69a1.689 1.689 0 0 1 1.716 1.907c0 .9-.308 1.445-1.318 2.327a3.961 3.961 0 0 0-1.731 3.411v.7h2.434v-.508c0-.989.291-1.521 1.348-2.468a4.216 4.216 0 0 0 1.7-3.538 3.79 3.79 0 0 0-4.145-3.938A4.287 4.287 0 0 0 6.97 4.485a3.86 3.86 0 0 0-1.077 2.827v.107h2.415a1.721 1.721 0 0 1 1.753-1.941Z" fill="currentColor"></path></svg>
                                        </button>
                                        <ul class="dropdown-menu dropdown-menu-end width_200p">
                                            <li><button class="dropdown-item d_flex_start" type="button"> <span class="d_inline_flex mr_5"><i class="material-symbols-outlined font_16p">headset_mic</i></span> <span class="d_inline_flex">Support Center</span> </button></li>
                                            <li><button class="dropdown-item custom_border_top" type="button"> Permission Request </button></li>
                                            <li><button class="dropdown-item custom_border_top" type="button">Smart Q</button></li>
                                            <li><button class="dropdown-item" type="button"> User Guide </button></li>
                                            <li><button class="dropdown-item" type="button"> Open API Guide </button></li>
                                            <li><button class="dropdown-item" type="button"> CLI Guide </button></li>
                                            <li><button class="dropdown-item logout_btn" type="button"> Notice </button></li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="header_list_btn">
                                    <div class="btn-group dropdown-center">
                                        <button type="button" class="btn btn-secondary dropdown-toggle no_arrow" data-bs-toggle="dropdown" aria-expanded="false">
                                            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g><g><g><path fill="currentColor" d="M13.873 12.4H2.127l1.121-1.666.102-.152V5.25A4.655 4.655 0 0 1 7.998.602a4.657 4.657 0 0 1 4.654 4.648v5.332l.102.152 1.119 1.666z"></path><path d="m12.748 11.8-.695-1.034V5.25a4.056 4.056 0 0 0-4.055-4.048A4.053 4.053 0 0 0 3.949 5.25v5.516l-.203.303-.492.73h9.494M15 13H1l1.75-2.6V5.25A5.247 5.247 0 0 1 7.998.002a5.249 5.249 0 0 1 5.254 5.248v5.15L15 13z" fill="transparent"></path></g><g stroke-width="1.2" stroke="transparent"><path fill="currentColor" d="M6 13.999h4a2 2 0 0 1-2 2 2 2 0 0 1-2-2z" stroke="none"></path><path d="M6.6 14.599h2.8a.8.8 0 0 1-.8.8H7.4a.8.8 0 0 1-.8-.8z" fill="none"></path></g></g></g></svg>
                                        </button>
                                        <ul class="dropdown-menu dropdown-menu-end width_268p">
                                            <h3 class="font_16p fw_bold">Notification</h3>
                                            <li><button class="dropdown-item custom_border_top d-block" type="button">Notice on Product and Service Update on Samsung Cloud Platform (07/19)</button></li>
                                            <li><button class="dropdown-item custom_border_top d-block" type="button">Infrastructure Maintenance Notice (2024.07.28)</button></li>
                                            <li><button class="dropdown-item custom_border_top d-block" type="button">EoTS of AI&MLOps Platform as k8s v1.22 reaches EoTS (7/18)</button></li>
                                            <li><button class="dropdown-item custom_border_top d-block" type="button">Notice of System Maintenance for Service Improvements (July.18)</button></li>
                                            <li><button class="dropdown-item custom_border_top d-block" type="button">Notice of Redis(DBaaS) product name change (6/18)</button></li>
                                            <li><button class="dropdown-item custom_border_top d-block" type="button">SCP Cloud WAN Infrastructure Maintenance Notice (June 20, 2024)</button></li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                            <li class="header_user pr_0">
                                <div class="header_list_btn">
                                    <div class="btn-group dropdown-center">
                                        <button type="button" class="btn btn-secondary dropdown-toggle no_arrow" data-bs-toggle="dropdown" aria-expanded="false">
                                            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Zm3-14a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm1.368 10c.342 0 .632-.259.632-.6 0-2.982-2.239-5.4-5-5.4s-5 2.418-5 5.4c0 .341.29.6.632.6h8.736Z" fill-rule="evenodd" fill="currentColor"></path></svg>
                                        </button>
                                        <ul class="dropdown-menu dropdown-menu-end width_268p">
                                            <li>
                                              <router-link :to="{ name: 'manage_account', params: { slug: 'my-account' } }">
                                                <button class="dropdown-item" type="button">My Account</button>
                                              </router-link>
                                            </li>
                                            <li>
                                              <router-link :to="{ name: 'my_inquiry'}">
                                                <button class="dropdown-item" type="button">My Inquiry</button>
                                              </router-link>
                                            </li>
                                            <li>
                                              <router-link :to="{ name: 'manage_account', params: { slug: 'my-service' } }">
                                                <button class="dropdown-item" type="button">My Service</button>
                                              </router-link>
                                            </li>
                                            <li>
                                              <router-link :to="{ name: 'manage_account', params: { slug: 'payment-cost' } }">
                                                <button class="dropdown-item" type="button">Payment & Cost</button>
                                              </router-link>
                                            </li>
                                            <!-- <li>
                                              <router-link :to="{ name: 'manage_account', params: { slug: 'security-credential' } }">
                                                <button class="dropdown-item" type="button">Security Credential</button>
                                              </router-link>
                                            </li>
                                            <li>
                                              <router-link :to="{ name: 'manage_account', params: { slug: 'my-coupon' } }">
                                                <button class="dropdown-item" type="button">My Coupon</button>
                                              </router-link>
                                            </li> -->
                                            <li @click.prevent="logout">
                                                <button class="dropdown-item logout_btn" type="button">Log out</button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                            <!-- <li class="service_portal_link right_menu_icon">
                                <a href="#">
                                    <span> Service Portal </span>
                                    <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                        <path fill="currentColor" transform="rotate(45 323.235 -711.954)" style="fill:none;stroke-linecap:round;stroke-width:1.4px" d="M608 26.036V14.379" stroke="currentColor"></path>
                                        <path fill="currentColor" transform="translate(-605.861 -12.365)" style="stroke-linejoin:round;fill:none;stroke-linecap:round;stroke-width:1.4px" d="M610.861 15.365h6v6" stroke="currentColor"></path>
                                    </svg>
                                </a>
                            </li> -->
                        </ul>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </header>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import router from "@/routes";

export default {
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
      activatable: true,
    }
  },
  computed: {
    ...mapGetters({
      customer: 'auth/getUserInfo',
      services: 'auth/getCustomerServices',
    }),
    ...mapGetters('dashboardTabs', ["allTabs", "activeTab"]),
    activeTabId() {
      return this.activeTab ? this.activeTab.id : null;
    },
    selectedService() {
      if (this.customer?.selected_service_id) {
        return this.services.find((service) => service?.id === parseInt(this.customer?.selected_service_id))
      }
      return null;
    }
  },
  watch: {
    $route: {
      handler(to) {
        if (this.activatable) {
          this.$store.dispatch('dashboardTabs/updateTabRoute', {id:this.activeTabId, route: to})
        }
      },
      deep: true,
      immediate: true
      // window.$(".dropdown_menu").removeClass('open')
    },
    activeTab: {
      handler(newVal) {
        this.$store.dispatch('dashboardTabs/updateTabRoute', {id:newVal.id, route: newVal.route})
      },
      deep: true,
      immediate: true
    },
  },
  created() {
    // this.$store.dispatch('dashboardTabs/updateTabRoute', this.$route);
    if (this.activeTabId && this.activeTab) {
      // this.$router.push({name: this.activeTab.route.name});
    }
  },
  methods: {
    reload(name){
      if(this.$route.name === name){
        this.$store.commit('setReload', true)
      }
    },
    logout() {
      this.axios.post('/logout').finally(() => {
        this.$store.dispatch('auth/logout')
        this.$router.push({name: 'login'})
      })
    },
    async selectTab(tabId) {
      if (this.activeTab) {
        setTimeout(async () => {
          let tab = this.allTabs.find((tab) => tab.id === tabId)

          this.$store.dispatch('dashboardTabs/setActiveTab', tabId)

          this.$router.push({name: tab.route.name});
        }, 100)
      }
    },
    addNewTab() {
      this.$store.dispatch('dashboardTabs/addTab', { name: 'dashboard' })
      router.push({ name: 'dashboard' });
    },
    closeTheTab(tabId) {
      this.$store.dispatch('dashboardTabs/closeTab', tabId)
    },
    formatText(text) {
      return text?.split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
    },
    setSelectedService(serviceId) {
      this.axios.post(`/set-customer-selected-service/${serviceId}`).then(( { data }) => {
        if (data.success) {
          this.$store.dispatch('auth/customerInfo', data.data)
          this.$store.dispatch('serverPermissions/servicePermissionList')
        }
      })
    },
  },
  beforeUnmount() {
  },
}
</script>

<style scoped>

</style>